import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Card,
  Col,
  Form,
  Tab,
  Tabs,
  Row,
  ToggleButton,
  Button,
  Overlay,
  Popover,
  Spinner,
  Modal,
} from 'react-bootstrap';
import CloseButton from 'react-bootstrap/CloseButton';
import BuySellService from '../../../services/buy-sell.service';
import { toast } from 'react-toastify';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import Loader from 'shared/common/loader';
import { userStore } from '../../../store/UserStore';
import OrderSummary from './order-summary';
import OrderConfirmation from './order-confirmation';
import '../styles.css';
import CurrencyInput from 'react-currency-input-field';
import { formatAmount, getDocumentType, toBase64 } from '../../../utils';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import KYCPopup from 'shared/common/kycPopup';
import passbookService from 'services/passbook.service';
import RedirectToast from 'shared/common/toast/redirectToast';
import { useHistory } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  BUYBACK_INVOICE_UPLOAD_MESSAGE,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
  TRADEMARK_LOGO_URL,
  BANK_TRANSFER_APPROVAL_PENDING,
} from 'constants/messages.constant';

import format from 'string-template';
import { dashboardStore } from 'store/DashboardStore';
import { Formik, Form as FormikForm, Field } from 'formik';
import * as Yup from 'yup';

import infoIco from '../../../assets/images/i-circle.svg';
import DashboardHttp from 'pages/profile/services/profile.service';
import CouponModal from 'shared/common/modal/couponModal';
import NomineeModal from 'pages/profile/components/NomineeModal';
import Redirect from 'shared/common/redirection/Redirect';
// import RedeemGiftModal from 'pages/gift-module/RedeemGiftModal';
import { fireCouponConfetti } from 'utils/confetti';

interface PropsType {
  metals: any;
  walletBalance: number;
  isDashboard: boolean;
  setSelectedMetalData?: any;
  getPassbookSummary: any;
  selectedMetalData?: any;
  getMetalTransactions?: any;
  giftMetal?: any;
  KycFraudCompleteFunction?: any;
}

interface ExtendedRazorpayOptions extends RazorpayOptions {
  config?: {
    display: RazorpayOptions['config']['display'] & {
      blocks: Record<string, any>;
      sequence: string[];
      preferences: Record<string, any>;
    };
  };
}

const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];

let typingTimer;

const SUPPORTED_FORMATS = [
  // 'image/jpg',
  // 'image/jpeg',
  // 'image/png',
  'application/pdf',
  // 'application/msword',
];
const FILE_SIZE = 5 * 1024 * 1024;

const BuySellMetals: React.FC<PropsType> = ({
  metals,
  walletBalance,
  isDashboard,
  setSelectedMetalData,
  getPassbookSummary,
  selectedMetalData,
  getMetalTransactions,
  giftMetal,
  KycFraudCompleteFunction,
}) => {
  const targetBuy = useRef(null);
  const toastId = React.useRef(null);
  const targetSell = useRef(null);
  const Razorpay = useRazorpay();
  const history = useHistory();
  const abortControllerRef = useRef<AbortController>(new AbortController());
  const [metalObject, setMetalObject] = useState<any>({});
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [quoteError, setQuoteError] = useState(false);
  const [metalCode, setMetalCode] = useState(giftMetal ? giftMetal : 'Ag');
  const [dislayOrderSummary, setDislayOrderSummary] = useState(false);
  const [quoteType, setQuoteType] = useState('');
  const [quoteAmount, setQuoteAmount] = useState('');
  const [askPrice, setAskPrice] = useState('');
  const [bidPrice, setBidPrice] = useState('');
  const [priceBreakdown, setPriceBreakdown] = useState(null);
  const [isPriceBreakdownShowBuy, setIsPriceBreakdownShowBuy] = useState(false);
  const [isPriceBreakdownShowSell, setIsPriceBreakdownShowSell] =
    useState(false);
  const [paymentMethod, setPaymentMethod] = useState('UPI');
  const [loading, setLoading] = useState<any>(false);
  const [isRedirect, setIsRedirect] = useState<any>(false);
  const [esignLoading, setEsignLoading] = useState(false);
  const [intervalIdQuote, setIntervalIdQuote] = useState<any>('');
  const [modalTrue, setModalTrue] = useState<any>(false);
  const [panBuyType, setPanBuyType] = useState<any>('');
  const [otpMeta, setOtpMeta] = useState<any>({
    otpId: '',
    otp: '',
    refType: 'B2B-BUYBACK',
    expiredAt: '',
  });

  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });

  //new code start
  const [showCoupon, setShowCoupon] = useState(false);
  const [couponList, setCouponList] = useState<any>([]);
  const [couponId, setCouponId] = useState('');
  const [couponName, setCouponName] = useState('');
  const [showCouponBox, setShowCouponBox] = useState(false);
  // palladium issue change
  const [newMetalCode, setnewMetalCode] = useState('Ag0003');

  const [useWallet, setUseWallet] = useState(false);
  const [OrderPayMethod, setOrderPayMethod] = useState([]);

  const childFunc = React.useRef(null);
  //new code end

  useEffect(() => {
    if (otpData.value?.length === 6) onSubmitOTP();
  }, [otpData.value]);


  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const [customerId, user, userData, selectedAccount, customer, setCustomer] =
    userStore((state: any) => [
      state.customerId,
      state.user,
      state.userData,
      state.selectedAccount,
      state.customer,
      state.setCustomer,
    ]);
  const [metalOrder] = dashboardStore((state: any) => [state.metalOrder]);
  const [quoteData, setQuoteData] = useState({
    items: [],
    type: 'SELL',
    currency: 'INR',
    ebActRef: selectedAccount.accountId,
  });

  const [item, setItem] = useState({
    itemCode: '',
    uom: 'g',
    requestedValue: null,
    requestedValueAmount: null,
    requestedValueQuantity: null,
    requestedType: 'PRODUCT_QTY',
    otherItems: [],
  });

  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });

  const [currentTab, setCurrentTab] = useState('SELL');
  const [orderData, setOrderData] = useState<any>(null);
  const [isPanUpdateRequired, setIsPanUpdateRequired] = useState(false);
  const [isKYCRequired, setIsKYCRequired] = useState(false);
  //  monthly weekly sip
  // const [isSipOpen, setIsSipOpen] = useState(false);
  // const [sipInterval, setSipInterval] = useState('');

  const [isOrderSummaryBuy, setIsOrderSummaryBuy] = useState(false);
  const [isOrderSummarySell, setIsOrderSummarySell] = useState(false);

  const [isOTPModalShow, setIsOTPModalShow] = useState(false);

  const [documentUpload, setDocumentUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64File, setBase64File] = useState('');

  useEffect(() => {
    if (orderData) {
      setDislayOrderSummary(true);
      // setIsRedirect(true);
      setTimeout(() => {
        if (giftMetal) {
          // setIsRedirect(false);
          history.push('/gift');
        }
      }, 2000);
    } else {
      setDislayOrderSummary(false);
    }
  }, [orderData]);

  useEffect(() => {
    if (customer.companyData?.eSign?.documentStatus === 'Completed')
      setDocumentUpload(false);
  }, [customer]);

  useEffect((): any => {
    setMetalCode(giftMetal);
    if (!isDashboard) {
      const filteredMetal = metals.filter(
        (x: any) => x.metalCode === selectedMetalData.metal
      );

      if (filteredMetal.length > 0) {
        onChangeMetal(selectedMetalData.metal, filteredMetal[0], true);
      }
    } else {
      const selectedMetal = metals.find((x: any) => x.metalCode === metalCode);
      // console.log('filteredMetal', selectedMetal);

      if (selectedMetal) {
        onChangeMetal(selectedMetal?.metalCode, selectedMetal, true);
      }
    }

    return () => {
      const controller = abortControllerRef.current;
      controller.abort();
    };
    // eslint-disable-next-line
  }, []);

  useEffect((): any => {
    if (Object.keys(selectedAccount).length > 0) {
      setQuoteData({
        ...quoteData,
        ebActRef: selectedAccount.accountId,
      });
    }
    // eslint-disable-next-line
  }, [selectedAccount]);

  /**
   * Change side modal state
   * @param value
   */
  const onHandleSideModal = (value) => {
    setDislayOrderSummary(false);
    if (!value) getPassbookSummary(customerId, user?.userId);
  };

  const checkPanRequirement = async (value, type) => {
    // if (quoteData?.type === 'SELL') {
    //   if (item?.requestedType == 'AMOUNT' && item?.requestedValue < 100)
    //     return toast.error('Amount should be more than ₹100');
    //   else if (item?.requestedType == 'PRODUCT_QTY' && item?.requestedValue < 1)
    //     return toast.error('Quantity should be more than 1g');
    // }
    // if (customer?.isFirstBuy == false && customer?.nomineeDetails?.length < 1) {
    //   if (customer.customerCategory === 'UNREGISTERED') {
    //     return setModalTrue(true);
    //   }
    // }
    if (KycFraudCompleteFunction) {
      const res = await KycFraudCompleteFunction();
      if (res) {
        return;
      }
    }
    if (
      quoteData?.type === 'SELL' &&
      paymentMethod === 'CUSTOMER_WALLET' &&
      Number(walletBalance) < priceBreakdown.summary.quotationTotal
    ) {
      setLoading(false);
      return toast.error(
        <RedirectToast
          btnLabel='Go to Wallet'
          label='Wallet balance is not enough'
          showButton
          onBtnClick={() => {
            history.push('/wallet');
          }}
        />,
        { closeOnClick: false }
      );
    }

    if (!customer?.kyc?.pan?.isVerified) {
      // if (type == 'SELL' && !customer?.kyc?.pan?.isVerified) {
      let panData = {
        customerId: customerId,
        amount: priceBreakdown?.summary?.quotationTotal,
      };
      try {
        const response: any = await CustomerOnboardingHttp.panThresholdCheck(
          panData
        );

        if (response.data.data.data == 'true' && type == 'SELL') {
          setLoading(false);
          setIsKYCRequired(false);
          if (type == 'SELL') onHandleOrderSummary(value, type);
          else checkLockinPeriod(value, type);
        } else {
          let data = {
            amount: priceBreakdown?.summary?.quotationTotal,
          };
          setPanBuyType(type);
          setInitialStateItem();
          // setPriceBreakdown(null)
          // setIsOrderSummarySell(false);
          // setIsOrderSummaryBuy(false);

          setLoading(true);
          setIsKYCRequired(true);

          try {
            const response: any = await CustomerOnboardingHttp.checkPanLimit(
              data
            );
            if (response.status === 200 && response.data) {
              setIsPanUpdateRequired(
                response.data.data.isPanVerificationRequired
              );
            }

            setLoading(false);
          } catch (error) {
            setIsPanUpdateRequired(false);
            setLoading(false);
          }
        }
      } catch (error) {
        setIsPanUpdateRequired(false);
        setLoading(false);
      }
    } else {
      setIsKYCRequired(false);
      if (type == 'SELL') onHandleOrderSummary(value, type);
      else checkLockinPeriod(value, type);
    }
  };

  const orderPaymentMethodSummary = async () => {
    try {
      const data = {
        quotationTotal: priceBreakdown.summary.quotationTotal,
        custId: customerId,
        paymentMethod: paymentMethod,
      };
      const res: any = await passbookService.getOrderPayMethodSummary(data);
      setOrderPayMethod(res?.data?.data)
    } catch (err) {
      console.log(err);
    }
  };

  const checkLockinPeriod = async (value, type) => {
    setLoading(true);
    let quoteId = priceBreakdown?.ebQuoteRef;
    try {
      const response: any = await BuySellService.checkLockinPeriod(quoteId);
      if (response.status === 200 && response.data) {
        if (
          quoteData?.type !== 'SELL' &&
          quoteData.items[0].requestedValue &&
          customer.customerCategory === 'REGISTERED' &&
          (!customer.companyData?.eSign ||
            customer.companyData.eSign.documentStatus !== 'Completed')
        ) {
          if (customer.isBrIgnored === false) {
            setDocumentUpload(true);
            return;
          }
        }
        onHandleOrderSummary(value, type);
      }
    } catch (err: any) {
      console.error(err);
      if (err?.data?.errors[0].title) {
        toast.error(err?.data?.errors[0].title);
      }
    } finally {
      setLoading(false);
    }
  };

  /**
   * Change side modal state
   * @param value
   * @param type
   */
  const onHandleOrderSummary = async (value, type) => {
    // check customer upi is verified
    if (paymentMethod === 'UPI') {
      const res: any = await BuySellService.addQuote(
        quoteData,
        user?.userId,
        abortControllerRef?.current?.signal
      );
      const maxLimit = res.data.data.meta.payLimits.filter(
        (data: any) =>
          data.provider === res.data.data.meta.currentUpiProvider &&
          data.method === paymentMethod
      )[0].maxLimit;
      if (res.data?.data?.summary?.quotationTotal > maxLimit)
        return toast.error(
          'The maximum limit for a UPI transaction is ₹' + maxLimit
        );

      // if (type === 'BUY') {
      //   if (
      //     Object.keys(customer.upiDetails).length === 0 ||
      //     customer.upiDetails.state === 'REJECTED' ||
      //     customer.upiDetails.state === 'PENDING'
      //   )
      //     return toast.error('Please verify your UPI details');
      // }
    }

    // check customer bank account is verified
    if (type === 'BUY') {
      if (
        paymentMethod === 'NEBK' ||
        paymentMethod === 'NEFT' ||
        paymentMethod === 'BANK_TRANSFER'
      ) {
        if (
          Object.keys(customer.bankDetails).length === 0 ||
          customer.bankDetails.state === 'REJECTED' ||
          customer.bankDetails.state === 'PENDING' ||
          customer.bankDetails.state === 'VERIFICATION_PENDING' ||
          !customer.bankDetails.accountNo
        )
          return toast.error(
            <RedirectToast
              btnLabel='Go to Profile'
              label='Please verify your bank details'
              showButton
              onBtnClick={() => {
                history.push('/profile?bank=true');
              }}
            />,
            { closeOnClick: false }
          );
      }
    }

    if (type === 'SELL') {
      orderPaymentMethodSummary();
      setIsOrderSummarySell(value);
    } else {
      setIsOrderSummaryBuy(value);
    }
  };

  /**
   * Set metal code
   * @param value
   * @param metal
   * @param isInitial
   */
  const onChangeMetal = async (
    value: any,
    metal: any,
    isInitial: boolean = false
  ) => {
    if (toast.isActive(toastId.current)) {
      toast.dismiss(toastId.current);
    }
    setMetalCode(value);
    setItem({
      ...item,
      itemCode: metal?.itemCode,
    });

    if (quoteError) {
      setItem({
        ...item,
        requestedValue: null,
        requestedValueQuantity: null,
        requestedValueAmount: null,
      });
      setQuoteError(false);
    }

    updateQuote(quoteAmount, quoteType, metal.itemCode);

    if (!isDashboard && !isInitial) {
      setSelectedMetalData(value);
    }
    setMetalObject(metal);
    const controller = abortControllerRef.current;
    controller.abort();

    onRemoveCoupon();
  };

  /**
   * Set metal amount
   * @param name
   * @param value
   */
  const onChangeBuyMetal = (value, name) => {
    setQuoteType(name);
    setQuoteAmount(value);
    let itemCopy = { ...item };

    itemCopy.requestedValue = value;
    if (name === 'amount') {
      itemCopy.requestedValueAmount = value;
      itemCopy.requestedType = 'AMOUNT';
      setItem(itemCopy);
    }

    if (name === 'grams') {
      itemCopy.requestedValueQuantity = value;
      itemCopy.requestedType = 'PRODUCT_QTY';
      setItem(itemCopy);
    }
    if (couponList.length !== 0) {
      onRemoveCoupon();
    }
  };

  useEffect(() => {
    // if (!priceSet.current) {
    //   priceSet.current = true;
    //   doneTyping();
    // }

    if (!item.requestedValue) {
      setIsPriceBreakdownShowBuy(false);
      setIsPriceBreakdownShowSell(false);
    }
  }, [item]);

  useEffect(() => {
    // if (!priceSet.current) {
    //   priceSet.current = true;
    //   doneTyping();
    // }

    if (currentTab === 'SELL') {
      setIsPriceBreakdownShowSell(false);
    } else {
      setIsPriceBreakdownShowBuy(false);
    }
  }, [currentTab]);

  useEffect(() => {
    addQuote();
  }, [quoteData]);

  const fileChanged = async (event: any) => {
    setSelectedFile(event.currentTarget.files[0]);
    let file: any = await toBase64(event.currentTarget.files[0]);
    setBase64File(file);
  };

  const formatValue = (value) => {
    if (typeof value === 'string') {
      return Number(value.replace(/,/g, ''));
    } else {
      return value;
    }
  };

  /**
   * @param value Desired Amount or Quanity
   * @param name Type of transaction
   * @param itemCode Metal Item code required for quote update
   */
  const updateQuote = (value, name, itemCode) => {
    let itemCopy = { ...item };

    if (metalCode) {
      itemCopy.itemCode = itemCode;
    }

    itemCopy.requestedValue = value;
    if (name === 'amount') {
      itemCopy.requestedValueAmount = value;
      itemCopy.requestedType = 'AMOUNT';
      setItem(itemCopy);
    }

    if (name === 'grams') {
      itemCopy.requestedValueQuantity = value;
      itemCopy.requestedType = 'PRODUCT_QTY';
      setItem(itemCopy);
    }

    quoteData.items = [];
    quoteData.items.push(itemCopy);

    setQuoteData({
      ...quoteData,
      items: quoteData.items,
    });
  };

  /**
   * Set payment method value
   * @param e
   */
  const onChangePaymentMethod = async (e) => {
    setIsPriceBreakdownShowBuy;
    const { value } = e.target;
    setPaymentMethod(value);
  };

  /**
   * Executes when the user done with typing
   */
  const doneTyping = () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      quoteData.items = [];
      quoteData.items.push(item);

      setQuoteData({
        ...quoteData,
        items: quoteData.items,
      });
    }, 750);
  };

  /**
   * Executed when user clicks on Addition pill buttons
   * @param value Addition value
   * @param name amount or grams
   */
  const onAdditionPillClick = (value, name) => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      updateQuote(value, name, metalObject.itemCode);
    }, 10);
  };

  const time = new Date();
  time.setSeconds(time.getSeconds() + 300);
  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp: time,
    onExpire: () => addQuote(),
  });

  const addQuote = useCallback(async () => {
    try {
      let newQuoteData = JSON.parse(JSON.stringify(quoteData));

      if (
        quoteData.items[0].requestedValue != undefined &&
        quoteData.items[0].requestedValue != null &&
        quoteData.items[0].requestedValue != ''
      ) {
        newQuoteData.items[0].requestedValue = formatValue(
          quoteData.items[0].requestedValue
        );
      } else {
        newQuoteData.items[0].requestedValue = null;
        newQuoteData.items[0].requestedType = 'PRODUCT_QTY';
      }

      setQuoteLoading(true);
      if (isOrderSummaryBuy || isOrderSummarySell) {
        setLoading(true);
      }
      setPriceBreakdown(null);
      setAskPrice('Loading...');
      setBidPrice('Loading...');

      const updateddata = {
        ...newQuoteData,
        discountId: couponName,
      };

      abortControllerRef.current = new AbortController();

      const res: any = await BuySellService.addQuote(
        couponName !== '' ? updateddata : newQuoteData,
        user?.userId,
        abortControllerRef.current.signal
      );
      setLoading(false);
      setQuoteLoading(false);
      if (res) {
        // Handle Quote Expiry
        if (res.data.data.validUntil) {
          // const newTime = new Date();
          // newTime.setSeconds(newTime.getSeconds() + 20);
          const ntime = new Date(res.data.data.validUntil);
        }
        //   restart(newTime);
        // } else {

        const newTime = new Date();
        newTime.setSeconds(newTime.getSeconds() + 300);
        restart(newTime);
        // }
        if (res.status === 201 && res.data.data) {
          setQuoteError(false);
          setPriceBreakdown(res.data.data);

          let finalAmount = formatValue(
            res.data.data.items[0].itemBreakDown[0].summary.lineTotal
          );

          let finalQuantity = formatValue(
            res.data.data.items[0].itemBreakDown[0].summary.finalQuantity
          );

          let unitPrice =
            res.data.data.items[0].itemBreakDown[0].summary.unitPrice;

          if (
            quoteData.items[0].requestedValue != undefined &&
            quoteData.items[0].requestedValue != null &&
            quoteData.items[0].requestedValue != ''
          ) {
            setItem({
              ...item,
              requestedValue:
                item.requestedType !== 'AMOUNT' ? finalQuantity : finalAmount,
              requestedValueQuantity: finalQuantity,
              requestedValueAmount: finalAmount,
            });
            if (currentTab === 'SELL') {
              setAskPrice(unitPrice);

              setIsPriceBreakdownShowSell(true);
              setIsPriceBreakdownShowBuy(false);
            } else {
              setBidPrice(unitPrice);
              setIsPriceBreakdownShowSell(false);
              setIsPriceBreakdownShowBuy(true);
            }
          }
          if (currentTab === 'SELL') {
            setAskPrice(unitPrice);
          } else {
            setBidPrice(unitPrice);
          }
          if (isOrderSummaryBuy || isOrderSummarySell) {
            // setLoading(false);
            if (toast.isActive(toastId.current)) {
              toast.dismiss(toastId.current);
              toastId.current = toast.success(
                'Quotation was successfully updated'
              );
            } else {
              toastId.current = toast.success(
                'Quotation was successfully updated'
              );
            }
          }

          //new code
          // return true;
        } else if (res.status === 200 && res.data.data) {
          if (res.data.data.code === 500) {
            setAskPrice(res.data.data.payload.unitPrice);
            setBidPrice(res.data.data.payload.unitPrice);
            setItem({
              ...item,
              requestedValue: null,
              requestedValueQuantity: null,
              requestedValueAmount: null,
            });
            setQuoteError(true);
            if (isOrderSummaryBuy || isOrderSummarySell) {
              setLoading(false);
            }
            if (toast.isActive(toastId.current)) {
              toast.dismiss(toastId.current);
              toastId.current = toast.error(res.data.data.title);
            } else {
              toastId.current = toast.error(res.data.data.title);
            }
          } else if (res.data.data.code === 400) {
            setAskPrice(res.data.data.payload.unitPrice);
            setBidPrice(res.data.data.payload.unitPrice);
            setItem({
              ...item,
              requestedValue: null,
              requestedValueQuantity: null,
              requestedValueAmount: null,
            });
            if (isOrderSummaryBuy || isOrderSummarySell) {
              setLoading(false);
            }
            if (res.data.data.title !== 'Request Amount/Qty not found') {
              setQuoteError(true);
              if (toast.isActive(toastId.current)) {
                toast.dismiss(toastId.current);
                toastId.current = toast.error(res.data.data.title);
              } else {
                toastId.current = toast.error(res.data.data.title);
              }
            }
          }
        }

        if (res.status == 201 && res.data.data) {
          if (res.data.data.items[0].itemBreakDown[0].discount.length > 0) {
            setShowCouponBox(true);
            toast.success('Coupon applied successfully');
          } else {
            setShowCouponBox(false);
          }
        }
        // else {
        //   setQuoteError(true);
        //   setQuoteLoading(false);
        //   if (isOrderSummaryBuy || isOrderSummarySell) {
        //     setLoading(false);
        //   }
        //   if (res.data.errors.length > 0) {
        //     toast.error(res.data.errors[0].title);
        //     return false;
        //   }
        // }
      }
    } catch (err: any) {
      setAskPrice('');
      setBidPrice('');
      setQuoteLoading(false);
      if (isOrderSummaryBuy || isOrderSummarySell) {
        setLoading(false);
      }
      if (err?.data?.errors?.length > 0) {
        if (toast.isActive(toastId.current)) {
          toast.dismiss(toastId.current);
          toastId.current = toast.error(err.data.errors[0].title);
        } else {
          toastId.current = toast.error(err.data.errors[0].title);
        }
      } else {
        // toast.error('Something went wrong');
      }

      onRemoveCoupon();
      // return false;
    }
  }, [quoteData]);

  /**
   * Handle payment related information
   */
  const handlePayment = async (payload?: any) => {
    try {
      clearInterval(intervalIdQuote);
      setIsPriceBreakdownShowSell(false);
      setIsOrderSummarySell(false);
      if (!priceBreakdown)
        return toast.error('Please fill the required details.');

      // if (!customer.bankDetails?.state) {
      //   let payload = {
      //     referenceId: customerId,
      //     type: 'BANK',
      //   };
      //   setLoading(true);
      //   const res: any = await BuySellService.createDefaultAccount(payload);
      //   setLoading(false);

      //   if (res.status === 200 && res.data.data) {
      let order_payload = {
        ebQuoteRef: priceBreakdown.ebQuoteRef,
        paymentMethod: paymentMethod,
        ...payload,
      };
      return await placeOrder(order_payload);
      // }
      // } else {
      //   let payload = {
      //     ebQuoteRef: priceBreakdown.ebQuoteRef,
      //     paymentMethod: paymentMethod,
      //   };
      //   setLoading(true);
      //   return await placeOrder(payload);
      // }
    } catch (err: any) {
      if (err.data.errors.length > 0) {
        return toast.error(err.data.errors[0].title);
      }
      return toast.error('Something went wrong');
    }
  };

  const getOrderDetails = async (orderRef) => {
    try {
      setLoading(true);
      const res: any = await passbookService.getOrderDetails(
        orderRef,
        user?.userId
      );
      if (
        res.status === 200 &&
        res.data.data.result &&
        res.data.data.result.length > 0
      ) {
        setOrderData(res.data.data.result[0]);
        return res.data.data.result[0];
      }
      setLoading(false);
      return;
    } catch (e: any) {
      return;
    }
  };

  const checkPaymentStatus = async (paymentId, orderId) => {
    try {
      let payload = {
        paymentId,
        orderId,
      };
      setLoading(true);
      const res = await BuySellService.checkPaymentStatus(
        payload,
        abortControllerRef.current.signal
      );
    } catch (error) {
    } finally {
      setLoading(false);
      await getProfile(customerId);
      let newData = await getOrderDetails(orderId);
      return await handleOrderSummaryModal(newData);
    }
  };

  /**
   * Set payment gateway configuration
   */
  const setPaymentGatewayConfiguration = async (data) => {
    setLoading(false);
    const options: ExtendedRazorpayOptions = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: '',
      currency: 'INR',
      name: 'eBullion',
      description: 'Buy Metals',
      image:
        'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
      order_id: '',
      async handler(response: any) {
        setLoading(true);
        const payload = {
          customerId: razorpay.customerId,
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          razorpayRequestBody: {
            amount: razorpay.amount,
            currency: 'INR',
            // test: 'testUPIwithRPY',
          },
        };

        // const res: any =
        //   paymentMethod === 'UPI'
        //     ? await BuySellService.verifyUPIPaymentRazorpay(payload)
        //     : await BuySellService.verifyNEBKPaymentRazorpay(payload);
        // if (res.status === 200 && res.data.data) {
        setInitialStateRazorpay();
        await checkPaymentStatus(
          response.razorpay_payment_id,
          data?.ebOrderRef
        );
        // }
      },
      prefill: {
        name: user.displayName,
        email: user.email.value,
        contact: user.mobile.value,
        method:
          paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI'
            ? 'upi'
            : 'netbanking',
      },
      modal: {
        ondismiss: () => {
          console.log('Payment popup closed.');
          window.location.reload(); // Refresh the page
        },
      } as any,
      config: {
        display: {
          language: 'en',
          blocks: {
            banks: {
              name:
                paymentMethod === 'UPI' ? 'Pay via UPI' : 'Pay via Net Banking',
              instruments: [
                {
                  method:
                    paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI'
                      ? 'upi'
                      : 'netbanking',
                },
              ],
            },
          },
          sequence: ['block.banks'],
          preferences: {
            show_default_blocks: false,
          },
        },
      },

      notes: {
        address: selectedAccount.billingAddress.address1,
      },
      theme: {
        hide_topbar: false,
        color: '#141034',
        backdrop_color: 'rgba(0, 0, 0, 0.90)',
      },
      timeout: 180,
    };

    // if (data.meta.payment.response.data.meta.length > 0) {
    //   options.order_id = data?.meta?.payment?.response.data.meta.filter(
    //     (data: any) => data.key === 'RPY_ORDER_ID'
    //   )[0].value;
    // }
    // razorpay.amount = data.meta.payment.response.data.amount;
    // options.amount = (razorpay.amount * 100).toString();
    // const razorPay = new Razorpay(options);
    // return razorPay.open();

    if (paymentMethod === 'UPI' || paymentMethod === 'WALLET_UPI') {
      if (
        data.meta.payment.response.data.meta.length > 0 &&
        data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'PAYMENT_PROVIDER'
        )[0].value === 'RPY'
      ) {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
        razorpay.amount = data.meta.payment.response.data.amount;
        options.amount = (razorpay.amount * 100).toString();
        const razorPay = new Razorpay(options);
        return razorPay.open();
      } else {
        setInitialStateRazorpay();
        setLoading(false);
        await handleOrderSummaryModal(data);
      }
    }

    if (paymentMethod === 'NEBK' || paymentMethod === 'WALLET_NEBK') {
      if (data.meta.payment.response.data.meta.length > 0) {
        options.order_id = data?.meta?.payment?.response.data.meta.filter(
          (data: any) => data.key === 'RPY_ORDER_ID'
        )[0].value;
      }
      razorpay.amount = data.meta.payment.response.data.amount;
      options.amount = (razorpay.amount * 100).toString();
      const razorPay = new Razorpay(options);
      return razorPay.open();

      // const res: any = await BuySellService.buyWithNEBK(razorpay);
      // if (res.status === 200 && res.data.data.notes.length > 0) {
      //   setLoading(false);
      //   options.amount = (razorpay.amount * 100).toString();
      //   options.order_id = res.data.data.notes[0].rpyOrderId;
      //   const razorPay = new Razorpay(options);
      //   return razorPay.open();
      // }
    }
  };

  /**
   * Place order in buyback
   */
  const buyBackPlaceOrder = async () => {
    if (
      paymentMethod === 'NEFT' ||
      (paymentMethod === 'BANK_TRANSFER' &&
        (Object.keys(customer.bankDetails).length === 0 ||
          customer.bankDetails.state === 'REJECTED' ||
          customer.bankDetails.state === 'PENDING' ||
          customer.bankDetails.state === 'VERIFICATION_PENDING' ||
          !customer.bankDetails.accountNo))
    ) {
      setLoading(false);
      return toast.error(
        <RedirectToast
          btnLabel='Go to Profile'
          label='Please verify your bank details'
          showButton
          onBtnClick={() => {
            history.push('/profile?bank=true');
          }}
        />,
        { closeOnClick: false }
      );
    } else {
      generateOtp('BUYBACK');
    }
  };

  /**
   * Place order according to the payment method
   * @param payload
   */
  const placeOrder = async (payload) => {
    setIsOTPModalShow(false);
    try {
      if (
        quoteData?.type === 'SELL' &&
        paymentMethod === 'CUSTOMER_WALLET' &&
        Number(walletBalance) < priceBreakdown.summary.quotationTotal
      ) {
        setLoading(false);
        return toast.error(
          <RedirectToast
            btnLabel='Go to Wallet'
            label='Wallet balance is not enough'
            showButton
            onBtnClick={() => {
              history.push('/wallet');
            }}
          />,
          { closeOnClick: false }
        );
      }
      if (quoteData?.type !== 'SELL') {
        if (
          paymentMethod === 'NEFT' ||
          (paymentMethod === 'BANK_TRANSFER' &&
            (Object.keys(customer.bankDetails).length === 0 ||
              customer.bankDetails.state === 'REJECTED' ||
              customer.bankDetails.state === 'PENDING' ||
              customer.bankDetails.state === 'VERIFICATION_PENDING' ||
              !customer.bankDetails.accountNo))
        ) {
          setLoading(false);
          return toast.error(
            <RedirectToast
              btnLabel='Go to Profile'
              label='Please verify your bank details'
              showButton
              onBtnClick={() => {
                history.push('/profile?bank=true');
              }}
            />,
            { closeOnClick: false }
          );
        }
      }

      setLoading(true);
      const res: any = await BuySellService.placeOrder(
        payload,
        abortControllerRef.current.signal,
        user?.userId
      );
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        if (quoteData?.type == 'BUYBACK') {
          setOrderData(res.data.data);
          await getPassbookSummary(customerId, user?.userId);
          setInitialStateItem();
          if (res.data.data.status === 'INVOICE_UPLOAD_PENDING')
            return toast.info(BUYBACK_INVOICE_UPLOAD_MESSAGE, {
              autoClose: false,
              closeOnClick: false,
            });
          else if (res.data.data.status === 'BANK_TRANSFER_APPROVAL_PENDING')
            return toast.info(BANK_TRANSFER_APPROVAL_PENDING, {
              autoClose: false,
              closeOnClick: false,
            });
          else return toast.success('Order was successfully placed');
        }
        if (paymentMethod !== 'CUSTOMER_WALLET' && paymentMethod !== 'NEFT') {
          return await setPaymentGatewayConfiguration(res.data.data);
        }
        return await handleOrderSummaryModal(res.data.data);
      }
    } catch (err: any) {
      setLoading(false);
      setInitialStateItem();

      if (err.data.errors.length > 0) {
        return toast.error(err.data.errors[0].title);
      }
      return toast.error('Something went wrong');
    }
  };

  /**
   * Handle order summary modal
   */
  const handleOrderSummaryModal = async (data) => {
    if (!isDashboard) {
      await getMetalTransactions(0);
    }
    if (currentTab === 'BUYBACK') {
      setLoading(false);
      // if (customer.customerCategory === "UNREGISTERED") {
      //
      //   setOtpMeta({
      //     ...otpMeta,
      //     otp: data.meta.buybackOtp.otp,
      //     otpId: data.meta.buybackOtp.otpId,
      //     refType: "B2C-BUYBACK"
      //   })

      // setOrderData(data)
      // onHandleSideModal(true);
      // setInitialStateItem();
      // return toast.success('Order was successfully placed');
      // }
      setIsOTPModalShow(true);
      setOtpMeta({
        ...otpMeta,
        otp: data.meta.buybackOtp.otp,
        otpId: data.meta.buybackOtp.otpId,
        refType:
          customer.customerCategory === 'UNREGISTERED'
            ? 'B2C-BUYBACK'
            : 'B2B-BUYBACK',
      });
      // resendOTP(data.meta.buybackOtp.otpId);
    } else {
      setOrderData(data);
      setLoading(false);
      setInitialStateItem();

      return toast.success(
        'You have bought ' +
          (data.items.length > 0 &&
            data.items[0].itemBreakDown.length > 0 &&
            data.items[0].itemBreakDown[0].summary.originalQuantity.toFixed(
              4
            )) +
          'g of ' +
          data.items[0].itemBreakDown[0].name +
          ' at ₹' +
          (data.items.length > 0 &&
            data.items[0].itemBreakDown.length > 0 &&
            formatAmount(data.items[0].itemBreakDown[0].summary.unitPrice, 2)) +
          '/g for ₹' +
          formatAmount(data.quotationTotal)
      );
    }
  };

  // const generateOtpApi = useApi(BuySellService.generateOtp);

  const generateOtp = async (ruleType, otpId = null) => {
    // user.mobile.value
    setIsOrderSummaryBuy(false);
    setIsOrderSummarySell(false);
    let payload = user?.mobile?.value;
    try {
      setLoading(true);
      const res: any = await BuySellService.generateOtp(
        payload,
        ruleType,
        otpId,
        user?.userId
      );
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        setIsOTPModalShow(true);
        setOtpMeta({
          ...otpMeta,
          otpId: res.data.data.otpId,
          expiredAt: res.data.data.expiredAt,
        });
        return toast.success(
          'OTP has been sent to your registered mobile number.'
        );
      }
    } catch (e: any) {
      setLoading(false);
      return toast.error(e.data.errors[0].title);
    }
  };

  /**
   * Verify OTP
   * @param otp
   */
  const onSubmitOTP = async () => {
    try {
      setLoading(true);
      setOtpMeta({
        ...otpMeta,
        otp: otpData.value,
      });
      let payload = {
        otpId: otpMeta?.otpId,
        otp: parseInt(otpData?.value),
      };
      const res: any = await BuySellService.verifyOTP(payload, user?.userId);
      setLoading(false);
      if (res.status === 200 && res.data.data) {
        setOtpData({
          ...otpData,
          value: '',
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success('OTP verification successful');
        if (quoteData?.type === 'BUYBACK') {
          clearInterval(intervalIdQuote);
          setLoading(true);
          let data = {
            ebQuoteRef: priceBreakdown.ebQuoteRef,
            paymentMethod: paymentMethod,
          };
          setOtpMeta({
            otpId: '',
            otp: '',
            refType: 'B2B-BUYBACK',
            expiredAt: '',
          });

          setIsPriceBreakdownShowBuy(false);
          setIsOrderSummaryBuy(false);
          return await placeOrder(data);
        } else {
          handlePayment(payload);
        }
      }
    } catch (e: any) {
      setLoading(false);
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      return toast.error(e.data.errors[0].title);
    }
  };

  const handlePurchaseMetal = () => {
    if (paymentMethod === 'CUSTOMER_WALLET') {
      generateOtp('SELL');
    } else {
      handlePayment();
    }
  };

  /**
   * Set initial state to razorpay data
   */
  const setInitialStateRazorpay = () => {
    setRazorpay({
      customerId: customerId,
      amount: null,
      transactionTypeId: 'eb-o-00333',
      paymentMethod: 'NEBK',
    });
  };

  /**
   * Set selected tab key
   * @param tab
   */
  const onChangeTab = async (tab) => {
    setCurrentTab(tab);
    setItem({
      ...item,
      requestedType: 'PRODUCT_QTY',
      requestedValue: null,
      requestedValueQuantity: null,
      requestedValueAmount: null,
    });
    setQuoteData({
      ...quoteData,
      items: [
        {
          ...quoteData.items[0],
          requestedValue: null,
          requestedValueQuantity: null,
          requestedValueAmount: null,
          requestedType: 'PRODUCT_QTY',
        },
      ],
      type: tab,
    });

    if (tab === 'BUYBACK') {
      setIsPriceBreakdownShowSell(false);
    } else {
      setIsPriceBreakdownShowBuy(false);
    }
  };

  /**
   * Set item to initial state
   */
  const setInitialStateItem = () => {
    setItem({
      itemCode: '',
      uom: 'g',
      requestedValue: null,
      requestedValueAmount: null,
      requestedValueQuantity: null,
      requestedType: '',
      otherItems: [],
    });

    setMetalCode('');
    setAskPrice('');
    setBidPrice('');
    setPriceBreakdown(null);
  };

  /**
   * Set OTP value
   * @param e
   */
  const onChangeValue = (e) => {
    let { name, value } = e.target;

    setOtpMeta({
      ...otpMeta,
      [name]: Number(value),
    });
  };

  /**
   * Resend OTP
   */
  const resendOTP = async (otpId: number = 0) => {
    generateOtp(quoteData?.type === 'SELL' ? 'SELL' : 'BUYBACK', otpMeta.otpId);
  };

  const onKycModalClose = () => {
    setIsKYCRequired(false);
    onHandleOrderSummary(true, panBuyType);
    addQuote();
  };
  const onKycHide = () => {
    setIsKYCRequired(false);
  };

  const getItemValue = (type) => {
    return type === 'PRODUCT_QTY'
      ? item.requestedValueAmount
      : item.requestedValueQuantity;
  };

  const onItemFocus = (requestedType) => {
    setItem({
      ...item,
      // palladium issue change
      itemCode: newMetalCode,

      requestedType,
      requestedValue: priceBreakdown?.items[0].itemBreakDown[0].summary
        ?.lineTotal
        ? priceBreakdown?.items[0].itemBreakDown[0].summary?.lineTotal
        : item.requestedValue,
    });
  };

  const esignCallback = (response) => {
    setEsignLoading(false);
    if ('message' in response) {
      toast.success('Document e-signed and uploaded successfully');
      getProfile(customerId);
    }
    if ('error' in response) {
      toast.error('E-sign failed');
    }
  };

  const trimBase64 = (file) => {
    return file.split(',')[1];
  };

  const uploadDocument = async () => {
    if (base64File) {
      try {
        let payload = {
          companyId: customer.companyId,
          file: trimBase64(base64File),
          name: customer?.user?.firstName,
          documentName: selectedFile.name,
          email: userData.email,
          mobile: userData.phone_number,
        };
        setLoading(true);
        const res: any = await BuySellService.uploadDocument(
          payload,
          user?.userId
        );

        if (res.status == 200 && res.data) {
          let win: any = window;
          const obj = {
            logoUrl: TRADEMARK_LOGO_URL,
            callback: esignCallback,
          };
          const leegality = new win.Leegality(obj);
          leegality.init();
          leegality.esign(res.data.data.result.signUrl);
          setEsignLoading(true);
        }
      } catch (error) {
        toast.error('Error in uploading the file');
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('File not selected');
    }
  };

  const getProfile = async (customerId: any) => {
    try {
      setLoading(true);
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data) {
        setCustomer(userData.data.data.customer);
        // checkPanRequirement(true, 'BUY');
      }
    } catch (e: any) {
      console.log(e);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // new start code
  const hideCouponModal = () => {
    setShowCoupon(false);
  };

  const handleApplyCouponClick = async (value) => {
    // setShowCouponBox(true);
    setShowCoupon(true);
    await callCouponApi(value);
  };

  const callCouponApi = async (value) => {
    let metalName = metalsWithCode.filter(
      (x: any) => x.code === value.itemCode.slice(0, 2)
    )[0].name;

    try {
      const res: any = await BuySellService.getCouponList(
        customerId,
        metalName.toUpperCase(),
        value
      );
      if (res) {
        if (res.data.data.length === 0) {
          // toast.info('No coupons available at the moment');
        } else {
          setShowCoupon(!showCoupon);
          setCouponList(res);
        }
      }
    } catch (error: any) {
      if (error?.data.errors[0].title) {
        console.log(error?.data.errors[0].title);
        // toast.error(error?.data.errors[0].title);
      } else {
        toast.error('Something went wrong');
      }
    }
  };

  const onCouponApply = async (data, itemData) => {
    const metalName = metalsWithCode.find(
      (x) => x.code === quoteData?.items[0]?.itemCode?.slice(0, 2)
    )?.name;

    const nameExists =
      couponList?.data?.data?.filter(
        (item) => item?.name === data?.toUpperCase()
      )?.length > 0;

    try {
      if (!nameExists) {
        const res = await BuySellService.checkCouponValidity(
          customerId,
          metalName?.toUpperCase(),
          itemData,
          data
        );

        if (res.data.data === 'true') {
          setCouponName(data);
          setQuoteData({
            ...quoteData,
          });
        } else {
          toast.error('Invalid coupon code!');
          childFunc.current();
        }
      } else {
        setCouponName(data);
        setQuoteData({
          ...quoteData,
        });
      }
      setShowCoupon(false);
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
    }
  };

  const onRemoveCoupon = () => {
    setCouponId('');
    setCouponName('');
    setCouponList([]);
    childFunc.current();
  };

  useEffect(() => {
    if (couponName === '') {
      setShowCouponBox(false);
      setQuoteData({
        ...quoteData,
      });
    }
  }, [couponName]);

  const onResetCoupon = () => {
    setCouponList([]);
    childFunc.current();
  };

  // new end code
  const discount =
    priceBreakdown?.items[0]?.itemBreakDown[0]?.discount[0]?.issueDiscountType;

  // monthly / weekly sip
  // const isGotoSIPFunc = (sipInt) => {
  //   setIsSipOpen(true);

  //   setSipInterval(sipInt);
  // };
  // const closeSIPFunc = () => {
  //   setIsSipOpen(false);
  //   setSipInterval('');
  // };
  const gotoSIPfunction = (sipInter) => {
    let sipDashData = {
      sipAmount: Math.floor(item?.requestedValueAmount),
      sipInterval: sipInter,
      sipItemCode: item?.itemCode,
      sipMetalType: item?.itemCode?.slice(0, 2),
    };
    history.push('/sip', sipDashData);
  };

  // end of monthly / weekly sip

  useEffect(() => {
    if (currentTab == 'BUYBACK') {
      setPaymentMethod('BANK_TRANSFER');
    } else {
      setPaymentMethod('UPI');
    }
  }, [currentTab]);

  // console.log(priceBreakdown, '@priceBreakdown');

  useEffect(() => {
    if (useWallet && item.requestedValueAmount <= walletBalance) {
      setPaymentMethod('CUSTOMER_WALLET');
    } else if (useWallet && item.requestedValueAmount > walletBalance) {
      if (paymentMethod == 'UPI' || paymentMethod == 'CUSTOMER_WALLET') {
        setPaymentMethod('WALLET_UPI');
      } else if (paymentMethod == 'NEBK') {
        setPaymentMethod('WALLET_NEBK');
      }
    } else {
      if (paymentMethod == 'WALLET_UPI' || paymentMethod == 'CUSTOMER_WALLET') {
        setPaymentMethod('UPI');
      } else if (paymentMethod == 'WALLET_NEBK') {
        setPaymentMethod('NEBK');
      }
    }
  }, [useWallet, paymentMethod, item.requestedValueAmount]);


  useEffect(() => {
  if (showCouponBox) {
   fireCouponConfetti({ x: 0.75, y: 0.8 });
  }
}, [showCouponBox]);

  return (
    <>
      {isRedirect && <Redirect />}
      <Modal
        show={documentUpload}
        onHide={() => {
          setDocumentUpload(false);
        }}
        backdrop='static'
        keyboard={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h4>Upload Required Document(s)</h4>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{ brFile: '' }}
            validationSchema={Yup.object().shape({
              brFile: Yup.mixed()
                .nullable()
                .required('Document is required')
                .test('fileSize', 'File is bigger than 5MB', (value) => {
                  return value && value?.size <= FILE_SIZE;
                })
                .test(
                  'fileType',
                  'Unsupported file format. Please upload file in PDF format',
                  (value) => value && SUPPORTED_FORMATS.includes(value?.type)
                ),
            })}
            onSubmit={(values, { setFieldError, setFieldTouched }) => {
              uploadDocument();
            }}
          >
            {({ errors, touched, setFieldValue }) => (
              <FormikForm>
                <Form.Group className='mb-3 ' controlId='entForm.comp-spoc'>
                  <Form.Label>
                    {getDocumentType(customer.customerType).type}
                  </Form.Label>

                  <small className='text-muted mx-2'>
                    {`(${getDocumentType(customer.customerType).description})`}
                  </small>
                  <Field
                    type='file'
                    placeholder=''
                    name='brFile'
                    className='form-control mt-2'
                    // value={values.brFile}
                    value={undefined}
                    onChange={(e) => {
                      fileChanged(e);
                      setFieldValue('brFile', e.currentTarget.files[0]);
                    }}
                  />
                  <div className='error'>
                    {errors.brFile && touched.brFile && (
                      <small id='my-helper-text'>
                        <img src={infoIco} alt='' />
                        {errors.brFile}
                      </small>
                    )}
                  </div>
                </Form.Group>
                <Form.Group>
                  <Button
                    className='w-100 mt-3'
                    variant='primary'
                    type='submit'
                    disabled={loading}
                  >
                    Upload
                    {loading ? (
                      <Spinner animation='border' size='sm'></Spinner>
                    ) : null}
                  </Button>
                </Form.Group>
              </FormikForm>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <KYCPopup
        isKYCPopupDisplayed={isKYCRequired}
        isPanVerficationRequired={isPanUpdateRequired}
        closeModal={onKycModalClose}
        hideModal={onKycHide}
      ></KYCPopup>

      <OtpPopup
        show={isOTPModalShow}
        isLoading={loading}
        handleClose={() => {
          resetOtpData();
          setIsOTPModalShow(false);
        }}
        modalTitle={`Metal ${
          quoteData?.type === 'SELL' ? 'Purchase' : 'Sell'
        } Confirmation`}
        modalSubmitBtnText='Verify'
        onSubmit={() => onSubmitOTP()}
        otpLabel={format(OTP_SENT_TO_REG_MESSAGE, {
          suffixDigits: user?.mobile?.value?.slice(-4),
        })}
        enableResendTimer={true}
        resendHandler={() => {
          resetOtpData();
          resendOTP();
        }}
        otpChangeHandler={(value) => {
          setOtpData({
            value: value,
            ackMessage: '',
            ackMessageType: 'success',
          });
        }}
        resendButtonText='Resend OTP'
        ackMessage={otpData.ackMessage}
        ackMessageType={otpData.ackMessageType}
        numInputs={6}
        otpValue={otpData.value}
        resendInterval={30}
      />

      <OrderConfirmation
        handleModal={(value) => {
          if (!value) {
            clearInterval(intervalIdQuote);
          }
          checkPanRequirement(value, 'BUY');
        }}
        isShow={isOrderSummaryBuy}
        data={priceBreakdown}
        onProceedPayment={buyBackPlaceOrder}
        minutes={minutes}
        seconds={seconds}
        // OrderPayMethod={OrderPayMethod}
      />

      <OrderConfirmation
        handleModal={(value) => {
          if (!value) {
            clearInterval(intervalIdQuote);
          }
          checkPanRequirement(value, 'SELL');
        }}
        isShow={isOrderSummarySell && !isKYCRequired}
        data={priceBreakdown}
        onProceedPayment={handlePurchaseMetal}
        minutes={minutes}
        seconds={seconds}
        OrderPayMethod={OrderPayMethod}

      />
      {(loading || esignLoading) && <Loader />}
      <Card className=' trans-card'>
        <Card.Body>
          <Tabs
            defaultActiveKey='SELL'
            id='uncontrolled-tab-example'
            className='mb-3'
            onSelect={onChangeTab}
          >
            <Tab eventKey='SELL' title='Buy Metals'>
              <Form>
                <div className='d-flex justify-content-between mb-3 mt-3 tg-btns'>
                  {metalOrder.map((metal, idx) => (
                    <ToggleButton
                      // eslint-disable-next-line react/no-array-index-key
                      key={idx}
                      id={`radio-sl-${idx}`}
                      type='radio'
                      name='radio'
                      variant='outline-warning'
                      value={metal.metalCode}
                      checked={metalCode === metal.metalCode}
                      onChange={(e) => {
                        onChangeMetal(
                          e.currentTarget.value,
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )
                        );
                        setnewMetalCode(
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )?.itemCode || ''
                        );
                      }}
                    >
                      {metalsWithCode.filter(
                        (x: any) => x.code === metal.metalCode
                      ).length > 0
                        ? metalsWithCode.filter(
                            (x: any) => x.code === metal.metalCode
                          )[0].name
                        : ''}
                    </ToggleButton>
                  ))}
                </div>

                <Form.Group className='mb-3' controlId='askPrice'>
                  <div className='d-flex justify-content-between'>
                    <Form.Label>Price</Form.Label>
                    <Form.Label
                      role='button'
                      ref={targetSell}
                      onClick={() =>
                        setIsPriceBreakdownShowSell(!isPriceBreakdownShowSell)
                      }
                    >
                      Price Breakdown
                    </Form.Label>
                    <Overlay
                      target={targetSell.current}
                      show={
                        targetSell.current &&
                        !loading &&
                        isPriceBreakdownShowSell &&
                        !quoteError &&
                        currentTab === 'SELL' &&
                        !isOrderSummaryBuy &&
                        !isOrderSummarySell &&
                        !isKYCRequired
                      }
                      placement={
                        window.innerWidth >= 576 ? 'right-start' : 'top'
                      }
                    >
                      {(props) => (
                        <Popover id='popover-basic-sell' {...props}>
                          <Popover.Body>
                            {!priceBreakdown || quoteLoading ? (
                              // <Spinner animation='border' size='sm'></Spinner>

                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>₹ 0.00 /g</strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>{`0.0000 g`}</strong>
                                </p>

                                <p>
                                  Line Amount : <br />
                                  <strong>₹0.00</strong>
                                </p>

                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>₹0.00</strong>
                                </p>
                              </div>
                            ) : (
                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].itemBreakDown[0]
                                        .summary.unitPrice,
                                      2
                                    )}
                                    /g
                                  </strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>{`${priceBreakdown.items[0].itemBreakDown[0].qty.toFixed(
                                    4
                                  )} g`}</strong>
                                </p>
                                {priceBreakdown.items[0].itemBreakDown[0]
                                  .summary.adjustedQuantity !== 0 && (
                                  <p style={{ color: '#99834D' }}>
                                    Product Discount : <br />
                                    <strong
                                      style={{ color: '#99834D' }}
                                    >{`${priceBreakdown.items[0].itemBreakDown[0].summary.adjustedQuantity.toFixed(
                                      4
                                    )} g`}</strong>
                                  </p>
                                )}
                                <p>
                                  Line Amount : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].summary
                                        .totalLineAmount
                                    )}
                                  </strong>
                                </p>
                                {/* {priceBreakdown.items[0].itemBreakDown[0]
                                  .summary.metalDiscountQty !== 0 && (
                                  <p>
                                    Product Discount we : <br />
                                    <strong>{`${priceBreakdown.items[0].itemBreakDown[0].summary.metalDiscountQty.toFixed(
                                      4
                                    )} g`}</strong>
                                  </p>
                                )} */}
                                {priceBreakdown.summary.itemTotalDiscount !==
                                  0 && (
                                  <p>
                                    Discount : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.itemTotalDiscount
                                      )}
                                    </strong>
                                  </p>
                                )}
                                {/* 
                                  quotationTax - TCS or TDS
                                  quotationTotalTax - TCS or TDS + GST
                                  itemTotalTax - GST
                                */}
                                {priceBreakdown.summary.itemTotalTax !== 0 && (
                                  <p>
                                    GST : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.itemTotalTax
                                      )}
                                    </strong>
                                  </p>
                                )}
                                {priceBreakdown.summary.quotationTax !== 0 && (
                                  <p>
                                    TCS : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.quotationTax
                                      )}
                                    </strong>
                                  </p>
                                )}
                                {priceBreakdown.summary
                                  .quotationRoundingDifference !== 0 &&
                                  (priceBreakdown.summary
                                    .quotationRoundingDifference > 0 ||
                                    priceBreakdown.summary
                                      .quotationRoundingDifference < 0) && (
                                    <p>
                                      Rounding Difference : <br />
                                      <strong>
                                        {priceBreakdown.summary
                                          .quotationRoundingDifference > 0
                                          ? '₹ ' +
                                            formatAmount(
                                              priceBreakdown.summary
                                                .quotationRoundingDifference
                                            )
                                          : '- ₹ ' +
                                            formatAmount(
                                              priceBreakdown.summary
                                                .quotationRoundingDifference *
                                                -1
                                            )}
                                      </strong>
                                    </p>
                                  )}
                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.summary.quotationTotal
                                    )}
                                  </strong>
                                </p>
                              </div>
                            )}
                          </Popover.Body>
                        </Popover>
                      )}
                    </Overlay>
                  </div>
                  <Form.Control
                    type='text'
                    value={
                      askPrice
                        ? Number(askPrice)
                          ? `₹ ${formatAmount(Number(askPrice), 2)}`
                          : askPrice
                        : ''
                    }
                    className='text-right'
                    disabled
                  />
                  {askPrice ? (
                    <Form.Text id='askPrice' muted>
                      Refreshes in {minutes > 0 ? `${minutes}m ` : ``}
                      {`${seconds}s`}
                    </Form.Text>
                  ) : null}
                </Form.Group>
                <Row>
                  <Col md={6}>
                    <Form.Group className='mb-3' controlId='amountInRupees'>
                      <Form.Label>Amount in Rupees</Form.Label>
                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(askPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='amount'
                        value={getItemValue('PRODUCT_QTY')}
                        onFocus={() => {
                          onItemFocus('AMOUNT');
                        }}
                        onWheel={(e: any) => e.target.blur()}
                        onValueChange={onChangeBuyMetal}
                        onKeyUp={doneTyping}
                        decimalsLimit={2}
                        decimalScale={2}
                        placeholder='₹ 0.00'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        prefix='₹ '
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className='mb-3' controlId='amountInGrams'>
                      <Form.Label>Quantity in grams</Form.Label>
                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(askPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='grams'
                        value={getItemValue('AMOUNT')}
                        onFocus={() => {
                          onItemFocus('PRODUCT_QTY');
                        }}
                        onWheel={(e: any) => e.target.blur()}
                        onValueChange={onChangeBuyMetal}
                        onKeyUp={doneTyping}
                        decimalsLimit={4}
                        decimalScale={4}
                        placeholder='0.0000 g'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        suffix=' g'
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <div className='d-flex justify-content-between mb-3 mt-3 tg-btns'>
                    {item.requestedType === 'PRODUCT_QTY'
                      ? [1, 5, 10, 25].map((quantity, idx) => (
                          <Button
                            key={idx}
                            variant='outline-warning'
                            disabled={quoteLoading}
                            onClick={(e) => {
                              onAdditionPillClick(
                                item.requestedValueQuantity
                                  ? formatAmount(
                                      Number(item.requestedValueQuantity) +
                                        Number(quantity),
                                      4
                                    )
                                  : formatAmount(Number(quantity), 4),
                                'grams'
                              );
                            }}
                          >
                            + {quantity}g
                          </Button>
                        ))
                      : [500, 1000, 2000, 5000].map((amount, idx) => (
                          <Button
                            key={idx}
                            disabled={quoteLoading}
                            variant='outline-warning'
                            onClick={(e) => {
                              onAdditionPillClick(
                                item.requestedValueAmount
                                  ? Number(item.requestedValueAmount) +
                                      Number(amount)
                                  : Number(amount),
                                'amount'
                              );
                            }}
                          >
                            + ₹{amount}
                          </Button>
                        ))}
                  </div>
                </Row>

                {/* new code start */}
                {showCouponBox ? (
                  <div className='remove-coupon-div'>
                    <div className='remove-coupon-div-text'>
                      {/* {showConfetti && (
                        <div className='confetti-container'>
                          <ConfettiExplosion {...mediumProps} />
                        </div>
                      )} */}
                      <span>
                        {discount != null ? (
                          discount === 'PRODUCT_QTY' ? (
                            `You get : ${
                              discount !== null || discount !== undefined
                                ? priceBreakdown?.items[0]?.itemBreakDown[0]?.discount[0]?.value.toFixed(
                                    4
                                  ) +
                                  ` g of ${priceBreakdown?.items[0]?.itemBreakDown[0]?.discount[0]?.DiscountMetal}`
                                : ''
                            }`
                          ) : (
                            <>
                              {priceBreakdown?.items[0]?.itemBreakDown[0]
                                ?.discount[0]?.cashbackType == 'CASHBACK'
                                ? `CASHBACK : ₹ ${
                                    discount !== null
                                      ? priceBreakdown?.items[0]?.itemBreakDown[0]?.discount[0]?.value.toFixed(
                                          2
                                        )
                                      : ''
                                  }`
                                : `You save : ₹ ${
                                    discount !== null
                                      ? priceBreakdown?.items[0]?.itemBreakDown[0]?.discount[0]?.value.toFixed(
                                          2
                                        )
                                      : ''
                                  }`}
                            </>
                          )
                        ) : (
                          ''
                        )}
                      </span>
                      <span>Coupon applied : {couponName}</span>
                    </div>
                    <CloseButton
                      onClick={() => {
                        onRemoveCoupon(),
                          toast.info('The coupon has been removed');
                      }}
                    />
                  </div>
                ) : item.requestedValueAmount ? (
                  <div className='apply-coupon-text'>
                    <a onClick={(e) => handleApplyCouponClick(item)}>
                      <span>Apply coupon code</span>{' '}
                    </a>
                  </div>
                ) : null}

                <CouponModal
                  // ref={couponRef}
                  childFunc={childFunc}
                  isCouponPopupDisplayed={showCoupon}
                  isPanVerficationRequired={isPanUpdateRequired}
                  closeModal={hideCouponModal}
                  hideModal={hideCouponModal}
                  couponList={couponList}
                  onCouponApply={(data) => onCouponApply(data, item)}
                  onResetCoupon={onResetCoupon}
                />
                <div
                  className='container_checkbox form-control mb-2'
                  style={{ backgroundColor: '#eae6dd' }}
                >
                  <Form.Check
                    className=' '
                    type='checkbox'
                    label={
                      <span
                        style={{ fontSize: '14px', backgroundColor: '#eae6dd' }}
                      >
                        Wallet Money -{' '}
                        {!walletBalance ? (
                          <span style={{ color: '#99834d', fontWeight: '700' }}>
                            ₹ {formatAmount(0)}
                          </span>
                        ) : (
                          <span style={{ color: '#99834d', fontWeight: '700' }}>
                            ₹ {formatAmount(walletBalance)}
                          </span>
                        )}
                      </span>
                    }
                    name='pgwallet'
                    onClick={() => setUseWallet(!useWallet)}
                    disabled={
                      walletBalance <= 0 ||
                      Number(askPrice) === 0 ||
                      customer.active === 'DISABLED' ||
                      Object.keys(selectedAccount).length === 0 ||
                      selectedAccount.active === 'DISABLED' ||
                      quoteError
                    }
                  ></Form.Check>
                  {/* item.requestedValueAmount */}
                </div>
                {/* new code ends */}
                {(useWallet && item.requestedValueAmount > walletBalance) ||
                  !useWallet ? (
                  <Form.Group className='mb-3' controlId='paymentMethod'>
                    <Form.Label>Payment Method</Form.Label>
                    <Form.Select
                      aria-label='Default select example'
                      onChange={onChangePaymentMethod}
                      disabled={!priceBreakdown}
                    >
                      {/* <option value='NEBK'>Razorpay</option> */}
                      <option value='UPI'>UPI</option>
                      {getItemValue('PRODUCT_QTY') > 100 &&
                      <option value='NEBK'>Net Banking</option>}
                      {/* <option value='CUSTOMER_WALLET'>
                        Wallet - ₹ {formatAmount(walletBalance)}
                      </option> */}
                    </Form.Select>
                  </Form.Group>
                ) : null}
                
                <div className='d-grid mb-3 gap-2'>
                  {!useWallet && (
                    <Button
                      variant='primary'
                      disabled={
                        Number(askPrice) === 0 ||
                        customer.active === 'DISABLED' ||
                        Object.keys(selectedAccount).length === 0 ||
                        selectedAccount.active === 'DISABLED' ||
                        quoteError
                      }
                      onClick={() => gotoSIPfunction('daily')}
                      style={{ padding: '8px 16px', fontSize: '14px', lineHeight: '1.4' }}
                    >
                      Create SIP
                      <span style={{ fontSize: '11px', fontWeight: 400, opacity: 0.8, marginLeft: '6px' }}>
                        Daily · Weekly · Monthly
                      </span>
                    </Button>
                  )}

                  <Button
                    variant='primary'
                    disabled={
                      Number(askPrice) === 0 ||
                      customer.active === 'DISABLED' ||
                      Object.keys(selectedAccount).length === 0 ||
                      selectedAccount.active === 'DISABLED' ||
                      quoteError
                    }
                    onClick={() => checkPanRequirement(true, 'SELL')}
                    style={{ padding: '8px 16px', fontSize: '14px', lineHeight: '1.4' }}
                  >
                    Buy One Time
                  </Button>
                </div>
              </Form>
            </Tab>
            <Tab eventKey='BUYBACK' title='Sell Metals'>
              <Form>
                <div className='d-flex justify-content-between mb-3 mt-3 tg-btns'>
                  {metalOrder.map((metal, idx) => (
                    <ToggleButton
                      // eslint-disable-next-line react/no-array-index-key
                      key={idx}
                      id={`radio-bb-${idx}`}
                      type='radio'
                      name='radio'
                      variant='outline-warning'
                      value={metal.metalCode}
                      checked={metalCode === metal.metalCode}
                      onChange={(e) => {
                        onChangeMetal(
                          e.currentTarget.value,
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )
                        );
                        setnewMetalCode(
                          metals.find(
                            (item) => item.metalCode === metal.metalCode
                          )?.itemCode || ''
                        );
                      }}
                    >
                      {metalsWithCode.filter(
                        (x: any) => x.code === metal.metalCode
                      ).length > 0
                        ? metalsWithCode.filter(
                            (x: any) => x.code === metal.metalCode
                          )[0].name
                        : ''}
                    </ToggleButton>
                  ))}
                </div>

                <Form.Group className='mb-3' controlId='bidPrice'>
                  <div className='d-flex justify-content-between'>
                    <Form.Label>Price</Form.Label>
                    <Form.Label
                      role='button'
                      ref={targetBuy}
                      onClick={() =>
                        setIsPriceBreakdownShowBuy(!isPriceBreakdownShowBuy)
                      }
                    >
                      Price Breakdown
                    </Form.Label>
                    <Overlay
                      target={targetBuy.current}
                      show={
                        targetBuy.current &&
                        !quoteError &&
                        !loading &&
                        currentTab === 'BUYBACK' &&
                        isPriceBreakdownShowBuy &&
                        !isOrderSummaryBuy &&
                        !isOrderSummarySell
                      }
                      placement={
                        window.innerWidth >= 576 ? 'right-start' : 'top'
                      }
                    >
                      {(props) => (
                        <Popover id='popover-basic-buyback' {...props}>
                          <Popover.Body>
                            {priceBreakdown && !quoteLoading ? (
                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].itemBreakDown[0]
                                        .summary.unitPrice,
                                      2
                                    )}
                                    /g
                                  </strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>{`${priceBreakdown.items[0].itemBreakDown[0].summary.originalQuantity.toFixed(
                                    4
                                  )} g`}</strong>
                                </p>
                                {priceBreakdown.items[0].itemBreakDown[0]
                                  .summary.adjustedQuantity !== 0 && (
                                  <p style={{ color: '#99834D' }}>
                                    Product Discount : <br />
                                    <strong
                                      style={{ color: '#99834D' }}
                                    >{`${priceBreakdown.items[0].itemBreakDown[0].summary.adjustedQuantity.toFixed(
                                      4
                                    )} g`}</strong>
                                  </p>
                                )}
                                <p>
                                  Line Amount : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.items[0].summary
                                        .totalLineAmount
                                    )}
                                  </strong>
                                </p>
                                {priceBreakdown.items[0].itemBreakDown[0]
                                  .summary.metalDiscountQty !== 0 && (
                                  <p>
                                    Discount Quantity : <br />
                                    <strong>{`${priceBreakdown.items[0].itemBreakDown[0].summary.metalDiscountQty.toFixed(
                                      4
                                    )} g`}</strong>
                                  </p>
                                )}
                                {priceBreakdown.summary.itemTotalDiscount !==
                                  0 && (
                                  <p>
                                    Discount : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.itemTotalDiscount
                                      )}
                                    </strong>
                                  </p>
                                )}
                                {/* 
                                  quotationTax - TCS or TDS
                                  quotationTotalTax - TCS or TDS + GST
                                  itemTotalTax - GST
                                */}
                                {priceBreakdown.summary.itemTotalTax !== 0 && (
                                  <p>
                                    GST : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.itemTotalTax
                                      )}
                                    </strong>
                                  </p>
                                )}

                                {priceBreakdown.summary.quotationTax !== 0 && (
                                  <p>
                                    TDS : <br />
                                    <strong>
                                      ₹{' '}
                                      {formatAmount(
                                        priceBreakdown.summary.quotationTax
                                      )}
                                    </strong>
                                  </p>
                                )}
                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>
                                    ₹{' '}
                                    {formatAmount(
                                      priceBreakdown.summary.quotationTotal
                                    )}
                                  </strong>
                                </p>
                              </div>
                            ) : (
                              // <Spinner animation='border' size='sm'></Spinner>
                              <div>
                                <p>
                                  Rate : <br />
                                  <strong>₹ 0.00 /g</strong>
                                </p>
                                <p>
                                  Quantity : <br />
                                  <strong>{`0.0000 g`}</strong>
                                </p>

                                <p>
                                  Line Amount : <br />
                                  <strong>₹0.00</strong>
                                </p>

                                <p className='mb-0'>
                                  Total : <br />
                                  <strong>₹0.00</strong>
                                </p>
                              </div>
                            )}
                          </Popover.Body>
                        </Popover>
                      )}
                    </Overlay>
                  </div>
                  <Form.Control
                    type='text'
                    value={
                      bidPrice
                        ? Number(bidPrice)
                          ? `₹ ${formatAmount(Number(bidPrice), 2)}`
                          : bidPrice
                        : ''
                    }
                    className='text-right'
                    disabled
                  />

                  {bidPrice ? (
                    <Form.Text id='bidPrice' muted>
                      Refreshes in {minutes > 0 ? `${minutes}m ` : ``}
                      {`${seconds}s`}
                    </Form.Text>
                  ) : null}
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className='mb-3' controlId='amountInRupees'>
                      <Form.Label>Amount in Rupees</Form.Label>
                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(bidPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='amount'
                        value={getItemValue('PRODUCT_QTY')}
                        onWheel={(e: any) => e.target.blur()}
                        onFocus={() => {
                          onItemFocus('AMOUNT');
                        }}
                        onValueChange={onChangeBuyMetal}
                        onKeyUp={doneTyping}
                        placeholder='₹ 0.00'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        prefix='₹ '
                        decimalsLimit={2}
                        decimalScale={2}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className='mb-3' controlId='amountInGrams'>
                      <Form.Label>Quantity in grams</Form.Label>

                      <CurrencyInput
                        allowNegativeValue={false}
                        tabIndex={-1}
                        disabled={
                          Number(bidPrice) === 0 ||
                          customer.active === 'DISABLED' ||
                          Object.keys(selectedAccount).length === 0 ||
                          selectedAccount.active === 'DISABLED' ||
                          quoteLoading
                        }
                        className='form-control text-right'
                        name='grams'
                        value={getItemValue('AMOUNT')}
                        onWheel={(e: any) => e.target.blur()}
                        onValueChange={onChangeBuyMetal}
                        onFocus={() => {
                          onItemFocus('PRODUCT_QTY');
                        }}
                        onKeyUp={doneTyping}
                        placeholder='0.0000 g'
                        onKeyDown={() => clearTimeout(typingTimer)}
                        suffix=' g'
                        decimalsLimit={4}
                        decimalScale={4}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <div className='d-flex justify-content-between mb-3 mt-3 tg-btns'>
                    {item.requestedType === 'PRODUCT_QTY'
                      ? [1, 5, 10, 25].map((quantity, idx) => (
                          <Button
                            key={idx}
                            variant='outline-warning'
                            disabled={quoteLoading}
                            onClick={(e) => {
                              onAdditionPillClick(
                                item.requestedValueQuantity
                                  ? formatAmount(
                                      Number(item.requestedValueQuantity) +
                                        Number(quantity),
                                      4
                                    )
                                  : formatAmount(Number(quantity), 4),
                                'grams'
                              );
                            }}
                          >
                            + {quantity}g
                          </Button>
                        ))
                      : [500, 1000, 2000, 5000].map((amount, idx) => (
                          <Button
                            key={idx}
                            variant='outline-warning'
                            disabled={quoteLoading}
                            onClick={(e) => {
                              onAdditionPillClick(
                                item.requestedValueAmount
                                  ? Number(item.requestedValueAmount) +
                                      Number(amount)
                                  : Number(amount),
                                'amount'
                              );
                            }}
                          >
                            + ₹{amount}
                          </Button>
                        ))}
                  </div>
                </Row>

                <Form.Group className='mb-3' controlId='paymentMethod'>
                  <Form.Label>Payment Method</Form.Label>
                  <Form.Select
                    aria-label='Default select example'
                    onChange={onChangePaymentMethod}
                    // disabled={!priceBreakdown}
                    // disabled
                  >
                    {/* <option value='CUSTOMER_WALLET'>Wallet</option> */}
                    {/* {customer.customerCategory === 'REGISTERED' && ( */}
                    <option value='BANK_TRANSFER'>Bank Account</option>
                    {/* )} */}
                    {/* <option value='NEFT'>Bank Account</option> */}
                  </Form.Select>
                </Form.Group>
                <div className='d-grid mb-3'>
                  <Button
                    variant='primary'
                    disabled={
                      Number(bidPrice) === 0 ||
                      customer.active === 'DISABLED' ||
                      Object.keys(selectedAccount).length === 0 ||
                      selectedAccount.active === 'DISABLED' ||
                      quoteError
                    }
                    onClick={() => checkPanRequirement(true, 'BUY')}
                    className=''
                    size='lg'
                  >
                    Proceed
                  </Button>
                </div>
              </Form>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
      <OrderSummary
        key={'odrSmrpop'}
        handleModal={onHandleSideModal}
        isShow={dislayOrderSummary}
        data={orderData}
        isPassbookRedirect={true}
        displayInvoice={
          customer?.customerCategory !== 'REGISTERED' ||
          orderData?.type !== 'BUYBACK'
        }
        displaySummary={true}
      />
    </>
  );
};

export default BuySellMetals;
